import { BarChart3, Megaphone, LayoutGrid, Check } from "lucide-react";
import { useTranslation } from "@/i18n/useTranslation";
import { Reveal } from "@/components/Reveal";

type Group =
  | {
      Icon: typeof BarChart3;
      title: string;
      items: string[];
      text?: undefined;
    }
  | {
      Icon: typeof BarChart3;
      title: string;
      text: string;
      items?: undefined;
    };

const groups: Group[] = [
  {
    Icon: BarChart3,
    title: "Analyse",
    items: ["Google Analytics 4", "Google Tag Manager", "Matomo", "Plausible", "Hotjar", "Mixpanel"],
  },
  {
    Icon: Megaphone,
    title: "Marketing",
    items: ["Google Ads", "Meta Pixel", "TikTok Pixel", "LinkedIn Insight", "HubSpot", "Mailchimp"],
  },
  {
    Icon: LayoutGrid,
    title: "Website & Shop",
    text: "Mit allen Shop- und Website-Systemen kompatibel — eine Zeile Code, fertig.",
  },
];

export function Integrations() {
  const { t } = useTranslation();
  return (
    <section
      id="integrations"
      className="py-20 md:py-24 bg-white border-y border-border scroll-mt-16"
    >
      <div className="container mx-auto max-w-[1440px] px-5 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-14">
          <div className="text-xs font-semibold uppercase tracking-wider text-primary">
            {t("integrations.eyebrow")}
          </div>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold tracking-tight text-foreground">
            {t("integrations.title")}
          </h2>
          <p className="mt-4 text-muted-foreground leading-relaxed text-[0.98rem]">
            {t("integrations.subtitle")}
          </p>
        </div>

        {/* Three categorized columns of pill chips */}
        <div className="grid md:grid-cols-3 gap-x-10 gap-y-10 max-w-5xl mx-auto">
          {groups.map(({ Icon, title, items, text }, i) => (
            <Reveal key={i} delay={i * 80}>
              <div className="flex items-center gap-2.5 pb-3 border-b border-border">
                <span className="inline-flex w-8 h-8 rounded-lg bg-primary/10 text-primary items-center justify-center">
                  <Icon className="w-4 h-4" strokeWidth={1.75} />
                </span>
                <h3 className="text-[0.95rem] font-semibold text-foreground">
                  {title}
                </h3>
              </div>
              {items ? (
                <div className="mt-4 flex flex-wrap gap-2">
                  {items.map((name) => (
                    <span
                      key={name}
                      className="inline-flex items-center rounded-full border border-border bg-white px-3 py-1.5 text-[12px] font-medium text-foreground/80 hover:border-primary/40 hover:text-foreground transition-colors"
                    >
                      {name}
                    </span>
                  ))}
                </div>
              ) : (
                <div className="mt-4 flex items-start gap-2.5 text-sm text-muted-foreground leading-relaxed">
                  <Check className="w-4 h-4 mt-0.5 shrink-0 text-primary" strokeWidth={2.5} />
                  <p>{text}</p>
                </div>
              )}
            </Reveal>
          ))}
        </div>

        <p className="mt-10 text-center text-xs text-muted-foreground">
          {t("integrations.andMore")}
        </p>
      </div>
    </section>
  );
}
